import { c as _c } from "react/compiler-runtime";
import { isSizeUnit, SIZE_UNITS } from "@components/projects/projects-filters/projects-size-filter-utils";
import { Dropdown, NumberField, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";

/** A limit of a custom size range while the user types it, whose value is null when empty */

const UNIT_OPTIONS = SIZE_UNITS.map(unit => ({
  key: unit,
  value: unit,
  label: unit
}));
/** A field to type a limit of a custom size range and pick its unit */
export function SizeLimitField(t0) {
  const $ = _c(22);
  const {
    label,
    limit,
    onLimitChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "2.5rem",
      flexShrink: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <Text variant="bodyM" sx={t2}>{label}</Text>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${label} size`;
  let t5;
  if ($[4] !== limit || $[5] !== onLimitChange) {
    t5 = value => onLimitChange({
      ...limit,
      value
    });
    $[4] = limit;
    $[5] = onLimitChange;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== limit.value || $[8] !== t4 || $[9] !== t5) {
    t6 = <NumberField aria-label={t4} value={limit.value} min={0} fullWidth={true} onValueChanged={t5} />;
    $[7] = limit.value;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `${label} size unit`;
  let t8;
  if ($[11] !== limit || $[12] !== onLimitChange) {
    t8 = t9 => {
      const {
        target
      } = t9;
      if (isSizeUnit(target.value)) {
        onLimitChange({
          ...limit,
          unit: target.value
        });
      }
    };
    $[11] = limit;
    $[12] = onLimitChange;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== limit.unit || $[15] !== t7 || $[16] !== t8) {
    t9 = <Dropdown aria-label={t7} options={UNIT_OPTIONS} value={limit.unit} fullWidth={true} onChange={t8} />;
    $[14] = limit.unit;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t6 || $[20] !== t9) {
    t10 = <Stack direction="row" sx={t1}>{t3}{t6}{t9}</Stack>;
    $[18] = t3;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}